import { type LoaderFunctionArgs } from 'react-router';
import { redirect } from 'react-router';
import { ROUTER_PATH } from '@constants/routerItems.constant';
import { flowChatQuery } from '@pages/Flows/components/Flow/queries/flowChat.query';

const shareSessionLoader = async ({ params }: LoaderFunctionArgs) => {
  const { id = '', flowId = '' } = params;

  const result = await flowChatQuery.getShareSession(flowId, id);

  if (result.status === 'success') {
    return redirect(`${ROUTER_PATH.flows}/${flowId}/chat/${result.data.data.session.id}`);
  }

  if (result.status === 'error') {
    return redirect('/404');
  }

  return null;
};

export { shareSessionLoader };
